import AppCardStatusIndicator from './AppCardStatusIndicator';

export default AppCardStatusIndicator;